module.exports = __webpack_public_path__ + "media/images/xpass/icons/clipboard-5f59b2c3af04e2e87c4a7defc421d439.svg";